<template>
   <div id="app">
      <router-view/>
   </div>
</template>

<script>
export default {
   name: 'app',
   data () {
      return {
         msg: 'Commentoid.'
      }
   }   
}
</script>


<style>
/* Landing Page */

/* Apps */
#app {
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   cursor: default;
   overflow-x: hidden;
   overflow-y: auto;   
}

.pointer { 
   cursor: pointer; 
}

body {
   background: #FDFDFD; /* COLOR BODY CREAM ZEN */
   min-width: 320px;
   margin: 0px;
   -webkit-overflow-scrolling: touch;
}

.italicize {
   font-style: italic;
}

.bold {
   font-weight: bold;
}

.focus-underline {
   box-shadow: inset 0 0px 0 white, inset 0 -1px 0 #BA0D61;
}

::-webkit-scrollbar {
   display: none;
}

.scroll-container {
   overflow-y: auto;
   overflow-x: hidden;
   height: auto;
}

.no-scroll-container {
   overflow: hidden;
}

/* Colors */
.grey-out {
   color: #777777; /* COLOR GREY OUT */
}

.cpa-bk-grey {
   background-color: #EEEEEE; /* COLOR LIGHT GREY */
}

.cpa-bk-orange {
   background-color: #FFE8D7; /* COLOR LIGHT ORANGE */
}

/* Grid and Edit */
.cell-editable {
   cursor: cell;
   width: 100%;
   height: 100%;
}

.editable {
   cursor: crosshair;
}

/* UI Common */
.show {
    display: block !important;
}

.hide {
   visibility: hidden !important;
}

.remove {
   display: none !important;
}

h1, h2 {
   font-weight: normal;
}

h2 {
   font-weight: normal;
   font-size: 1.6rem;
}

.list-divider-line-light {
   border-bottom: solid 1px #EEEEEE;
}

/* Set default font sizes */
select, textarea, input[type="text"], input[type="password"], input[type="datetime"], input[type="datetime-local"], input[type="date"], input[type="month"], input[type="time"], input[type="week"], input[type="number"], input[type="email"], input[type="url"], input[type="search"], input[type="tel"], input[type="color"] { font-size: 1rem; }

/* Remove input boxes focus light blue outline */
input:focus,
select:focus,
textarea:focus,
a:focus,
button:focus {
    outline: none;
}

/* + Site Wide */
a, u {
    text-decoration: none;
}

a {
   color: #888888;
}
/* - Site Wide */

</style>



// WEBPACK FOOTER //
// src/Commentoid.vue